import { createContext, useContext, useMemo, useState } from 'react';
import { useTheme } from './ThemeContext';

const TORCH_VIDEO_IDS = ['torch-vid2', 'torch-vid3', 'torch-vid4', 'torch-vid5'];
import { SITE_CONFIG } from '../config/site';

// Torch artwork is fixed via src/config/site.js - no user-facing selector.
const DEFAULT_TORCH_VIDEO_ID = TORCH_VIDEO_IDS.includes(SITE_CONFIG.torchVideoId)
  ? SITE_CONFIG.torchVideoId
  : 'torch-vid5';

const LIGHT_TORCH_FILE_BY_ID = {
  'torch-vid2': 'wh-torch-vid3',
  'torch-vid3': 'wh-torch-vid3',
  'torch-vid4': 'wh-torch-vid4',
  'torch-vid5': 'wh-torch-vid5',
};

function fileBaseForTheme(videoId, theme) {
  if (theme === 'light') {
    return LIGHT_TORCH_FILE_BY_ID[videoId] ?? videoId;
  }
  return videoId;
}

const TorchVideoContext = createContext(null);

export function TorchVideoProvider({ children }) {
  const { theme } = useTheme();
  const [videoId, setVideoIdState] = useState(DEFAULT_TORCH_VIDEO_ID);

  const videoSrc = useMemo(
    () => `./videos/${fileBaseForTheme(videoId, theme)}.mp4`,
    [videoId, theme]
  );

  const setTorchVideoId = (id) => {
    if (TORCH_VIDEO_IDS.includes(id)) setVideoIdState(id);
  };

  return (
    <TorchVideoContext.Provider
      value={{ videoId, videoSrc, setTorchVideoId, torchVideoIds: TORCH_VIDEO_IDS }}
    >
      {children}
    </TorchVideoContext.Provider>
  );
}

export function useTorchVideo() {
  const ctx = useContext(TorchVideoContext);
  if (!ctx) {
    throw new Error('useTorchVideo must be used within TorchVideoProvider');
  }
  return ctx;
}
